import { FC } from 'react';

interface WarningTriangleIconProps {
  width?: string;
  height?: string;
  color?: string;
}

export const WarningTriangleIcon: FC<WarningTriangleIconProps> = ({
  width = '18',
  height = '16',
  color = 'currentColor',
}) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 18 16" fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.46687 1.25069C7.42894 -0.416898 9.83572 -0.416898 10.7978 1.25069L16.9264 11.8736C17.8879 13.5403 16.6851 15.6229 14.7609 15.6229H2.50373C0.579582 15.6229 -0.623275 13.5403 0.338263 11.8736L6.46687 1.25069ZM8.63251 5.62286C8.97768 5.62286 9.25751 5.90269 9.25751 6.24786V9.37286C9.25751 9.71804 8.97768 9.99786 8.63251 9.99786C8.28733 9.99786 8.00751 9.71804 8.00751 9.37286V6.24786C8.00751 5.90269 8.28733 5.62286 8.63251 5.62286ZM8.63251 12.4979C8.97768 12.4979 9.25751 12.218 9.25751 11.8729C9.25751 11.5277 8.97768 11.2479 8.63251 11.2479C8.28733 11.2479 8.00751 11.5277 8.00751 11.8729C8.00751 12.218 8.28733 12.4979 8.63251 12.4979Z"
        fill={color}
      />
    </svg>
  );
};
